const Logo = (props) => (
  <img style={{ width: 300 }}
    alt="Logo"
    src="/static/logo.png"
    {...props}
  />
);

export default Logo;
